<template>
  <el-container class="height100">
    <el-container  v-show="showmode=='LIST'">
      <el-container class="el-mainContent height100"  direction="vertical" ref="userLogMain">
        <el-row class="obpm-fromContent-title obpm-enterpriseDomain-logo normalHeight" ref="normalHeader">
          <el-col :span="16" class="normalLineH">
              {{$t('log')}}
              <span class="userlog-record" v-if='isSuper'>{{$t('userlog_record')}}</span>
              <el-switch v-model="isLog"  active-value="true" inactive-value="false" v-if='isSuper'></el-switch>
          </el-col>
          <el-col :span="8" class="align-right normalLineH"  v-if='isSuper'>
              <el-button type="primary" @click="onSaveBtnClick" size="small" plain>{{$t('save')}}</el-button>
              <el-button v-if="isSuper" @click="onDeleteBtnClick" size="small" type="danger" plain>{{$t('del')}}</el-button>
          </el-col>
        </el-row>
        <el-row ref="search">
          <el-col :span="24">
            <el-form :inline="true" :model="searchdata" class="form-inline" size="mini"  @submit.native.prevent>
              <el-form-item >
                <el-input v-model="searchdata.operator" :placeholder="$t('operator')"  @keyup.enter.native="searchTableData"></el-input>
              </el-form-item>
              <el-form-item >
                <el-input v-model="searchdata.ip" placeholder="IP"  @keyup.enter.native="searchTableData"></el-input>
              </el-form-item>
              <el-form-item >
                <el-date-picker
                  v-model="searchdata.date"
                  type="date"
                  format="yyyy 年 MM 月 dd 日"
                  value-format="yyyy-MM-dd"
                  :placeholder="$t('select_date')">
                </el-date-picker>
              </el-form-item>
              <el-form-item>
                <el-button @click="searchTableData" type="primary" plain>{{$t('query')}}</el-button>
                <el-button @click="resetSearchData">{{$t('reset')}}</el-button>
              </el-form-item>
            </el-form>
          </el-col>
          
        </el-row>
        <!-- 操作日志列表 -->
        <el-table 
          :data="logdata.datas"
          class="overflowYscroll"
          ref="multipleTable"
          :row-key="handleReserve" 
          @selection-change="handleSelectionChange"
          header-cell-class-name="tableHeaderbg"
          size="small"
          :height="tableListConHeight">>
          <!-- @row-click="onRowClick" -->
          <el-table-column type="selection" width="55" ></el-table-column>
          <el-table-column prop="operator" :label="$t('operator')"></el-table-column>
          <el-table-column prop="type" :label="$t('type')"></el-table-column>
          <el-table-column prop="description" :label="$t('description')"></el-table-column>
          <el-table-column prop="date" :label="$t('date')"></el-table-column>
          <el-table-column prop="ip" label="IP"></el-table-column>
        </el-table>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="searchTableData"
          :current-page.sync="searchdata.currpage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="searchdata.pagelines"
          layout="prev, pager, next, total, sizes"
          background
          :total="logdata.rowCount?logdata.rowCount:0"
        ></el-pagination>
      </el-container>
    </el-container>
    <el-container v-show="showmode=='DETAIL'">
      <userlog_detail :detail="content" @exit="onExit"/>
    </el-container>
    
  </el-container>
</template>

<script>
import userlog_detail from "@/components/userlog_detail.vue";

export default {
  components:{
    userlog_detail,
  },
  created() {
    this.isSuper = this.$store.state.currentUser.type=="super"?true:false;
    
    this.$api.getUserLogs(
      { domainid: this.$route.query.domainid,  currpage: "", pagelines:"",data:{operator: "", ip: "", date: "",}},
      {
        onSucess: resp => {
          this.logdata = resp.data.data;
          this.logdata.datas.forEach((elm)=>{
            elm.date=this.resolvingDate(elm.date);
          })
        }
      }
    );
    this.$api.getUserLogIslog(this.$route.query.domainid,
      {
        onSucess: resp => {
          this.isLog = resp.data.data;
        }
      }
    );
  },
  mounted(){
    // var h = document.documentElement.clientHeight || document.body.clientHeight;
    this.tableListConHeight=this.$refs.userLogMain.$el.getClientRects()[0].height-this.$refs.normalHeader.$el.getClientRects()[0].height-this.$refs.search.$el.getClientRects()[0].height;
    
  },
  data() {
    return {
      showmode:"LIST",
      logdata: {},
      searchdata:{
        operator:"",
        ip:"",
        date:"",
        currpage: 1,
        pagelines: 10
      },
      multipleTable:[],
      multipleSelection:[],
      isLog:"true",
      userDetailVisible:false,
      content:{},
      tableListConHeight:null,
      isSuper: "", //是否是管理员
      flag:localStorage.getItem("isDeparmentAdminRole")=="false"?false:true,
    };
  },
  methods:{
    onSaveBtnClick(){
      let isLogs={
        "isLog":this.isLog
      }
      this.$api.updateUserLogs(this.$route.query.domainid,
        isLogs
      ,{
        onSucess:resp =>{
          if(resp.data.errcode==0){
            this.$message({
                showClose: true,
                message: this.$t('msg_save_success'),
                type: "success"
              });
            this.searchTableData()
          }else{
            this.$message({
                showClose: true,
                message: resp.data.errmsg,
                type: "error"
              });
          }
        },
        onError:function(){

        }
      })
    },
    onDeleteBtnClick(){
      if(this.multipleSelection.length>0){
        this.$api.deleteLogdata(this.$route.query.domainid,{
          data:this.multipleSelection
        },{
          onSucess:resp =>{
            if(resp.data.errcode==0){
              this.$message({
                  showClose: true,
                  message: this.$t('msg_del_success'),
                  type: "success"
                });
              this.searchTableData()
            }else{
              this.$message({
                  showClose: true,
                  message: resp.data.errmsg,
                  type: "error"
                });
            }
          },
          onError:function(){

          }
        })
      }else{
        this.$message({
          showClose: true,
          message: this.$t('msg_select_data'),
          type: "error"
        });
      }
    },
    handleSelectionChange(val){
      var arr = [];
       val.forEach((val) => {
        this.logdata.datas.forEach((v) => {
          if(val.id == v.id){
            arr.push(val.id)
          }
        })
      })   
      this.multipleSelection = arr;
    },
    handleReserve(row){
      return row.id
    },
    handleSizeChange(size){
      this.searchdata.pagelines=size;
      this.searchTableData();
    },
    searchTableData(){
      this.$api.getUserLogs(
        { domainid: this.$route.query.domainid,currpage: this.searchdata.currpage, pagelines: this.searchdata.pagelines,data:{ operator: this.searchdata.operator, ip: this.searchdata.ip, date: this.searchdata.date, }},
        {
          onSucess: resp => {
            this.logdata = resp.data.data;
            this.logdata.datas.forEach((elm)=>{
              elm.date=this.resolvingDate(elm.date);
            })
          }
        }
      );
    },
    resetSearchData(){
      this.searchdata={
        operator:"",
        ip:"",
        date:"",
        currpage: 1,
        pagelines: 10
      };
      this.searchTableData();
    },
    onRowClick(row) {
      this.showDetail(row);
    },
    showDetail(dept) {
      this.content = dept;
      this.showmode = "DETAIL";
    },
    
    onExit(){
      this.showmode = 'LIST';
      this.searchTableData();
    },
    resolvingDate(date){
      let d = new Date(date);

      let month = (d.getMonth() + 1) < 10 ? '0'+(d.getMonth() + 1) : (d.getMonth() + 1);
      let day = d.getDate()<10 ? '0'+d.getDate() : d.getDate();
      let hours = d.getHours()<10 ? '0'+d.getHours() : d.getHours();
      let min = d.getMinutes()<10 ? '0'+d.getMinutes() : d.getMinutes();
      let sec = d.getSeconds()<10 ? '0'+d.getSeconds() : d.getSeconds();

      let times=d.getFullYear() + '-' + month + '-' + day + ' ' + hours + ':' + min + ':' + sec;

      return times
    }
  }

};
</script>

<style>
</style>